import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import genericHelpers from './generic-helpers';
import wasPriceType from '../_shelf-category/types/was-price-type';

const FLAGS = {
  1: { css: 'best_seller', text: 'Best Seller' },
  2: { css: 'clearance', text: 'Clearance' },
  4: { css: 'new', text: 'New' },
  8: { css: 'rollback', text: 'Rollback' },
  128: { css: 'secondary-flag foil-stamped', text: 'Real Foil Card' },
};

function titleize(str) {
  return (str || '').replace(/\b\w/g, l => l.toUpperCase());
}

function hasWasPrice(price, was_price) {
  const wasPrices = [].concat(was_price).filter(Boolean);
  return wasPrices.some(wp =>
    genericHelpers.isWasPriceValid({ was_price: wp, price })
  );
}

function getMaskFlags(flagValue) {
  const maskFlags = [];
  for (const mask in FLAGS) {
    if (flagValue & mask) {
      maskFlags.push(FLAGS[mask]);
    }
  }
  return maskFlags;
}

function getObjectFlags(flagArray, includeRollback) {
  const flags = Array.isArray(flagArray) ? [...flagArray] : [];
  if (includeRollback && flags.length === 0) {
    flags.push({ name: 'Rollback', colour: '' });
  }
  return flags;
}

const ProductFlags = props => {
  const { price, was_price, flag, className } = props;

  if (typeof flag === 'number') {
    const maskFlags = getMaskFlags(flag);
    if (hasWasPrice(price, was_price)) maskFlags.push(FLAGS[8]);
    if (maskFlags.length === 0) return null;
    return (
      <span className="flags">
        {maskFlags.map(({ css, text }) => (
          <span
            className={classNames('flag', css, className)}
            key={`${css}-${text}`}
          >
            {text}
          </span>
        ))}
      </span>
    );
  }

  const flagsToRender = getObjectFlags(flag, hasWasPrice(price, was_price));

  if (flagsToRender.length > 0) {
    return (
      <span className="flags">
        {flagsToRender.map(({ colour, name }) => (
          <span
            className={classNames(
              'flag',
              { 'secondary-flag foil-stamped': name === 'Real Foil Card' },
              name && name.toLowerCase().replace(/\s+/g, '-'),
              className
            )}
            key={`${colour}-${name}`}
            style={{ backgroundColor: colour }}
          >
            {titleize(name)}
          </span>
        ))}
      </span>
    );
  }

  return null;
};

ProductFlags.propTypes = {
  price: PropTypes.number,
  was_price: PropTypes.oneOfType([
    wasPriceType,
    PropTypes.arrayOf(wasPriceType),
  ]),
  flag: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object,
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        colour: PropTypes.string,
      })
    ),
  ]),
  className: PropTypes.string,
};

ProductFlags.defaultProps = {
  price: null,
  was_price: null,
  flag: null,
  className: null,
};

export default ProductFlags;
